import { Pencil, Trash2, User, Clock } from 'lucide-react';
import { CalendarProfessional } from '../../types/calendar';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  Button,
  EmptyState,
  Badge,
} from '../ui';

interface ProfessionalListProps {
  professionals: CalendarProfessional[];
  onEdit: (professional: CalendarProfessional) => void;
  onDelete: (professional: CalendarProfessional) => void;
  isLoading?: boolean;
}

function ProfessionalList({ professionals, onEdit, onDelete, isLoading }: ProfessionalListProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (professionals.length === 0) {
    return (
      <EmptyState
        icon={<User className="h-12 w-12" />}
        title="Nenhum profissional cadastrado"
        description="Cadastre seu primeiro profissional para começar a agendar horários"
      />
    );
  }

  return (
    <TableContainer>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Nome</TableHead>
            <TableHead>Especialidade</TableHead>
            <TableHead>Serviços</TableHead>
            <TableHead className="relative">
              <span className="sr-only">Ações</span>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {professionals.map(professional => (
            <TableRow key={professional.id}>
              <TableCell>{professional.name}</TableCell>
              <TableCell>{professional.specialty || '-'}</TableCell>
              <TableCell>
                <div className="flex flex-wrap gap-1">
                  {professional.service_types && professional.service_types.length > 0 ? (
                    professional.service_types.map((service, index) => (
                      <Badge key={index} variant="secondary" className="flex items-center gap-1">
                        <Clock className="h-3 w-3" />
                        {service.name} ({service.duration_minutes}min)
                      </Badge>
                    ))
                  ) : (
                    <span className="text-gray-400">Nenhum serviço</span>
                  )}
                </div>
              </TableCell>
              <TableCell className="text-right space-x-2">
                <Button variant="ghost" onClick={() => onEdit(professional)} title="Editar">
                  <Pencil className="h-4 w-4" />
                </Button>
                <Button variant="ghost" onClick={() => onDelete(professional)} title="Excluir">
                  <Trash2 className="h-4 w-4 text-red-600" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ProfessionalList;
